export default __webpack_public_path__ + "prepsharp.mp4";